import { gql } from '@apollo/client';

export type ArchiveLoadingOrderDetailResponse = {
  opsToolArchiveTmsLoadingOrderDetail: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const ARCHIVE_LOADING_ORDER_DETAIL = gql`
  mutation OpsToolArchiveTmsLoadingOrderDetail($taskId: Long!) {
    opsToolArchiveTmsLoadingOrderDetail(taskId: $taskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type CancelArchiveLoadingOrderDetailResponse = {
  opsToolCancelArchiveTmsLoadingOrderDetail: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const CANCEL_ARCHIVE_LOADING_ORDER_DETAIL = gql`
  mutation OpsToolCancelArchiveTmsLoadingOrderDetail($taskId: Long!) {
    opsToolCancelArchiveTmsLoadingOrderDetail(taskId: $taskId) {
      success
      code
      message
      updatedCount
    }
  }
`;
